import { ElButton, ElPagination } from "element-plus";
export default {
  components: {
    ElButton,
    ElPagination
  },
  methods: {
    // 可以写入全局方法等
  }
};